// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";

const apiUrl = "/api/v2/accounts";

export interface CreateProfessionalAccountApiParameter {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    primaryBusinessType: string;
    companyName: string;
    companyWebsite: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateOrProvince: string;
    country: string;
    zip: string;
    accountNumber: string | null;
    subscribeToNewsletter: boolean;
}

export const createProfessionalAccount = (parameter: CreateProfessionalAccountApiParameter) => {
    return post<CreateProfessionalAccountApiParameter, void>(`${apiUrl}/submit`, parameter);
};
